module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousAir
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Sea Import Payment")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [(_vm.mainEntryData.length > 0 && _vm.mainEntryData[0].shippingArrivalNoticmailSentDate == null) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.SendShipmentArrival
    }
  }, [_vm._v("Send Shipment Arrival Notice")]) : _vm._e()], 1), _vm._v(" "), _c('b-nav-form', [(_vm.mainPageModal.ffImportPayId != '') ? _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "success",
      "id": "addButtonLoaderpro"
    },
    on: {
      "click": _vm.proceedInvoice
    }
  }, [_vm._v("Generate Invoice")]) : _vm._e()], 1), _vm._v(" "), _c('b-nav-form', [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "size": "sm",
      "variant": "primary",
      "id": "addButtonLoaderVGM"
    },
    on: {
      "click": function($event) {
        _vm.emailChecklist('PAYTEST')
      }
    }
  }, [_vm._v("S-Line Payment Request")])], 1)], 1)], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.ALLMODULE ? this.ALLMODULE : '',
      "jobSeriesBanner": this.JOBSERIES ? this.JOBSERIES : '',
      "bannerClientName": this.CLIENTNAME ? this.CLIENTNAME : '',
      "iconId": "fa fa-ship",
      "prbr_id": this.prbr_id ? this.prbr_id : ''
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_vm._l((_vm.mainPageModal.doSection), function(item, index) {
    return _c('b-card', {
      key: index,
      staticClass: "gutr",
      staticStyle: {
        "background": "whiteSmoke"
      }
    }, [_c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "25"
      }
    }, [_c('label', {
      attrs: {
        "for": "stuffingType"
      }
    }, [_c('b', [_vm._v("Do / Security")])]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.doSecurityList,
        "option-value": "doSecV",
        "option-text": "doSecT",
        "placeholder": "Select "
      },
      model: {
        value: (item.doOrSecurity),
        callback: function($$v) {
          _vm.$set(item, "doOrSecurity", $$v)
        },
        expression: "item.doOrSecurity"
      }
    })], 1)], 1), _vm._v(" "), _c('md-layout', {
      staticClass: "gutr",
      staticStyle: {
        "margin-bottom": "15px"
      },
      attrs: {
        "md-gutter": ""
      }
    }, [_c('b-button', {
      staticStyle: {
        "margin-top": "42px"
      },
      attrs: {
        "size": "sm",
        "variant": "dark"
      },
      on: {
        "click": _vm.showDocModal
      }
    }, [_vm._v("Upload Document")]), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "20"
      }
    }, [_c('label', {
      attrs: {
        "for": "stuffingType"
      }
    }, [_vm._v("Document Details")]), _vm._v(" "), _c('b-textarea', {
      staticStyle: {
        "height": "37px"
      },
      attrs: {
        "name": "securityAmount",
        "id": "securityAmount"
      },
      model: {
        value: (item.doParticulars),
        callback: function($$v) {
          _vm.$set(item, "doParticulars", $$v)
        },
        expression: "item.doParticulars"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('label', {
      attrs: {
        "for": "stuffingType"
      }
    }, [_vm._v("Paid By")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.paidByList,
        "option-value": "paidV",
        "option-text": "paidT",
        "placeholder": "Select Paid By"
      },
      model: {
        value: (item.doPaidBy),
        callback: function($$v) {
          _vm.$set(item, "doPaidBy", $$v)
        },
        expression: "item.doPaidBy"
      }
    })], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "5"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('label', [_vm._v("Payment Date")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "format": _vm.selectDateFormat,
        "lang": "en",
        "id": "receivedDo",
        "name": "receivedDo"
      },
      model: {
        value: (item.doPaymentDate),
        callback: function($$v) {
          _vm.$set(item, "doPaymentDate", $$v)
        },
        expression: "item.doPaymentDate"
      }
    })], 1), _vm._v(" "), (index == '0') ? _c('b-button', {
      staticClass: "ml-2",
      staticStyle: {
        "margin-top": "34px"
      },
      attrs: {
        "size": "sm",
        "variant": "outline-dark"
      },
      on: {
        "click": _vm.addAdditionalDo
      }
    }, [_vm._v("\n                Add More\n              ")]) : _c('b-button', {
      staticClass: "ml-2",
      staticStyle: {
        "margin-top": "34px"
      },
      attrs: {
        "size": "sm",
        "variant": "outline-dark"
      },
      on: {
        "click": function($event) {
          _vm.removeDoSection(index)
        }
      }
    }, [_vm._v("\n                Remove\n              ")])], 1), _vm._v(" "), (item.uploadDoC != '') ? _c('md-layout', {
      attrs: {
        "md-gutter": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "25"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Import_Uploads/" + item.uploadDoC,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])], 1) : _vm._e()], 1)
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    staticStyle: {
      "margin-top": "42px"
    },
    attrs: {
      "size": "sm",
      "variant": "dark"
    },
    on: {
      "click": _vm.showDocModal
    }
  }, [_vm._v("Upload DO")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Do Release Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "receivedDo",
      "name": "receivedDo"
    },
    model: {
      value: (_vm.mainPageModal.doReleaseDate),
      callback: function($$v) {
        _vm.$set(_vm.mainPageModal, "doReleaseDate", $$v)
      },
      expression: "mainPageModal.doReleaseDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "50"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "doRemarks",
      "name": "doRemarks"
    },
    model: {
      value: (_vm.mainPageModal.doRemarks),
      callback: function($$v) {
        _vm.$set(_vm.mainPageModal, "doRemarks", $$v)
      },
      expression: "mainPageModal.doRemarks"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.secBlUploadView.length > 0) ? _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, _vm._l((_vm.secBlUploadView), function(item, index) {
    return _c('md-layout', {
      key: index,
      attrs: {
        "md-flex": "25"
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.docURL + "/FF_Sea_Import_Uploads/" + item,
        "target": "_blank",
        "download": ""
      }
    }, [_vm._v("View Document - " + _vm._s(index + 1))])])
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gutr"
  }, [_c('div', [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": function($event) {
        _vm.addPayment('0')
      }
    }
  }, [_vm._v("Save & Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "mt-1",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader1"
    },
    on: {
      "click": function($event) {
        _vm.addPayment('1')
      }
    }
  }, [_vm._v("Save & Proceed To Tracking")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)])], 2)], 1)], 1)], 1), _vm._v(" "), (_vm.ALLMODULE) ? _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n      ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop2",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "alertAddSeaImp",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseHandover
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "message",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fd7b3e0e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/seaImport/ffSeaImportExecution.vue
// module id = 2923
// module chunks = 0